import React, { useState } from "react";
import { Container, Navbar, Nav } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";

function AppNavbar() {
	let BaseUrl = window.location.pathname;

	const [activeLink] = useState(BaseUrl);
	const activeStyle = { color: "white" };

	return (
		<Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
			<Container>
				<Navbar.Brand href="/">Find a Doctor API</Navbar.Brand>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
				<Navbar.Collapse id="responsive-navbar-nav">
					<Nav className="ml-auto">
						<Nav.Link to="Home" href="/" style={activeLink === "/" ? activeStyle : {}}>Home</Nav.Link>
						<Nav.Link to="Providers" href="/providers" style={activeLink === "/providers" ? activeStyle : {}}>Providers</Nav.Link>
						<Nav.Link to="Practices" href="/practices" style={activeLink === "/practices" ? activeStyle : {}}>Practices</Nav.Link>
						<Nav.Link to="Report" href="/report" style={activeLink === "/report" ? activeStyle : {}}>Reports</Nav.Link>
						<Nav.Link href="https://app.swaggerhub.com/apis-docs/northwell-fad/northwell-fad-v3/3.0.0" style={activeLink === "/documentation" ? activeStyle : {}}>Documentation</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}

export default AppNavbar;
